<div class="oauth-callback-container safe-area-inset-top safe-area-inset-bottom">
  <div class="container-fluid">
    <div class="card callback-card">
      <!-- Estado de carga -->
      <div *ngIf="isLoading" class="card-body text-center">
        <div class="spinner-container">
          <div class="spinner"></div>
        </div>
        <h3 class="mt-3">{{ getProviderEmoji() }} Procesando...</h3>
        <p class="text-muted">
          Completando tu registro con {{ provider }}
        </p>
      </div>

      <!-- Estado de éxito -->
      <div *ngIf="success && !isLoading" class="card-body text-center">
        <div class="success-icon">
          <i class="fas fa-check-circle text-success" style="font-size: 4rem;"></i>
        </div>
        <h3 class="mt-3 text-success">{{ getProviderEmoji() }} ¡Registro exitoso!</h3>
        <p class="text-muted">
          Te has registrado correctamente con {{ provider }}.
        </p>
        <p class="text-muted">
          Serás redirigido al panel principal en unos segundos...
        </p>
        <button 
          type="button" 
          class="btn btn-success mt-3"
          (click)="goToDashboard()"
        >
          Ir al panel principal
        </button>
      </div>

      <!-- Estado de error -->
      <div *ngIf="error && !isLoading" class="card-body text-center">
        <div class="error-icon">
          <i class="fas fa-exclamation-triangle text-warning" style="font-size: 4rem;"></i>
        </div>
        <h3 class="mt-3 text-warning">{{ getProviderEmoji() }} Error de autenticación</h3>
        <div class="alert alert-warning mt-3">
          <p class="mb-0">{{ error }}</p>
        </div>
        
        <div class="mt-4">
          <button 
            type="button" 
            class="btn btn-primary me-2"
            (click)="retryOAuth()"
          >
            <i class="fas fa-redo"></i> Intentar de nuevo
          </button>
        </div>

        <p class="text-muted mt-3 small">
          Serás redirigido automáticamente en unos segundos...
        </p>
      </div>
    </div>

    <!-- Información adicional -->
    <div class="info-section mt-4 text-center">
      <p class="text-muted small">
        <i class="fas fa-info-circle"></i>
        Si experimentas problemas repetidos, puedes intentar:
      </p>
      <ul class="text-muted small text-start" style="max-width: 400px; margin: 0 auto;">
        <li>Limpiar las cookies de tu navegador</li>
        <li>Verificar que tengas habilitadas las ventanas emergentes</li>
        <li>Intentar con un navegador diferente</li>
      </ul>
    </div>
  </div>
</div>